import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';

const FAQS = [
  {
    q: 'Is ON THE WAY available in my city?',
    a: 'We currently operate in 12 Indian metros: Bangalore, Mumbai, Delhi NCR, Hyderabad, Chennai, Kolkata, Pune, Ahmedabad, Jaipur, Lucknow, Chandigarh and Kochi. Tier-2 expansion to Coimbatore, Indore and Visakhapatnam is planned for Q4 2026.',
  },
  {
    q: 'How is the fare calculated and is there any surge pricing?',
    a: 'Fares are calculated on a transparent base + per-km + per-minute model that you see upfront before confirming the ride. We cap surge at 1.6x during severe demand spikes (and 0% between 10:00 PM and 6:00 AM in off-hours — our promise).',
  },
  {
    q: 'What payment options do you support?',
    a: 'UPI (all major apps), credit/debit cards, OTW Wallet, and cash. Corporate billing with monthly invoices is available for business accounts.',
  },
  {
    q: 'How are drivers verified before they get on the platform?',
    a: 'Every driver goes through a 4-stage onboarding: government-ID verification, driving-licence + RC check, police background verification through partners, and a 2-day in-person training on safety, etiquette and the OTW app.',
  },
  {
    q: 'What if I leave something behind in the cab?',
    a: 'Open the trip details in your app and tap \u201cLost item\u201d \u2014 you will get a masked call to the driver instantly. Most items are returned within 24 hours; we charge only the return-trip fare.',
  },
  {
    q: 'How do I become an ON THE WAY driver?',
    a: 'Scroll up to “Drive with us” and submit your name, phone and city. Our local team calls back within 24 hours, schedules document verification, and you can typically start earning within 3 days.',
  },
  {
    q: 'Do you offer rentals or outstation rides?',
    a: 'Yes — OTW Rentals (hourly packages from 4 to 12 hours) and OTW Outstation (one-way and round-trip to 280+ Indian destinations) are available in 8 cities. Toll and parking are billed at actuals.',
  },
];

export default function Faqs() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faqs" className="bg-[#f5f5f3] py-24 md:py-32">
      <div className="max-w-[960px] mx-auto px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-[11px] font-semibold tracking-[0.18em] text-[#FF6A1A]">FREQUENTLY ASKED</span>
          <h2 className="mt-3 text-[34px] md:text-[46px] font-semibold tracking-[-0.02em] text-[#0f0f10]">
            Everything, made simple
          </h2>
          <p className="mt-4 text-[15px] md:text-[16px] text-[#6b6b70] leading-relaxed">
            Can’t find what you need? Email <a href="mailto:support@onthe-way.in" className="text-[#FF6A1A] font-semibold hover:underline">support@onthe-way.in</a> — we reply within 4 hours.
          </p>
        </div>

        <div className="mt-12 space-y-3">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className={`bg-white rounded-2xl ring-1 transition-all ${isOpen ? 'ring-[#FF6A1A]/40 shadow-[0_18px_40px_-25px_rgba(255,106,26,0.5)]' : 'ring-black/[0.05]'}`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 px-5 md:px-7 py-5 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="text-[15px] md:text-[17px] font-semibold text-[#0f0f10] tracking-[-0.005em]">{f.q}</span>
                  <span className={`w-9 h-9 rounded-full grid place-items-center flex-shrink-0 transition-colors ${isOpen ? 'bg-[#FF6A1A] text-white' : 'bg-[#f7f7f5] text-[#0f0f10]'}`}>
                    {isOpen ? <Minus size={16} /> : <Plus size={16} />}
                  </span>
                </button>
                <div
                  className={`grid transition-[grid-template-rows] duration-300 ease-out ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 md:px-7 pb-6 text-[14.5px] leading-relaxed text-[#3a3a3d]">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
